export const SPINNER_ACTION_TYPES = {

    SHOW_SPINNER: 'SHOW_SPINNER',
    HIDE_SPINNER: 'HIDE_SPINNER'
}